<template>
    <div class="inventory-view">
        <ContentLayout
            :image="heroImage"
            :height="400"
            :mobile-height="320"
            eyebrow="Inventaire"
            icon="mdi-car-multiple"
            title="Notre inventaire"
            subtitle="Des véhicules sélectionnés, présentés clairement, avec les détails essentiels en un coup d'oeil."
        >
            <template v-slot:hero-actions>
                <v-btn
                    x-large
                    color="secondary"
                    class="primary--text font-weight-bold mr-3 mb-3"
                    :href="'tel:' + $store.state.data.phone"
                >
                    <v-icon left>mdi-phone</v-icon>
                    {{ $store.state.data.phone }}
                </v-btn>
                <v-btn
                    x-large
                    outlined
                    color="white"
                    class="mb-3"
                    :to="{ name: 'services' }"
                >
                    <v-icon left>mdi-spray-bottle</v-icon>
                    Lavage d'auto
                </v-btn>
            </template>

        <section class="inventory-section">
            <v-container>
                <v-row align="end" class="mb-6">
                    <v-col cols="12" md="8">
                        <div class="overline secondary--text font-weight-bold mb-2">Véhicules disponibles</div>
                        <h2 class="display-1 font-weight-bold mb-3">
                            {{ query ? "Résultats de recherche" : "Parcourez l'inventaire" }}
                        </h2>
                        <p class="body-1 grey--text text--darken-1 mb-0">
                            {{ filteredItems.length }} véhicule{{ filteredItems.length > 1 ? "s" : "" }} affiché{{ filteredItems.length > 1 ? "s" : "" }}.
                        </p>
                    </v-col>
                    <v-col cols="12" md="4" class="text-md-right">
                        <v-btn
                            v-if="$store.state.user"
                            large
                            color="primary"
                            :to="{ name: 'item' }"
                        >
                            <v-icon left>mdi-plus</v-icon>
                            Ajouter un véhicule
                        </v-btn>
                        <v-chip
                            v-else
                            label
                            outlined
                            color="primary"
                            class="font-weight-bold"
                        >
                            <v-icon left>mdi-car-multiple</v-icon>
                            {{ filteredItems.length }} résultat{{ filteredItems.length > 1 ? "s" : "" }}
                        </v-chip>
                    </v-col>
                </v-row>

                <v-alert
                    v-if="query && !fetching"
                    outlined
                    color="primary"
                    class="mb-6"
                >
                    Recherche: <strong>{{ query }}</strong>
                    <span class="d-block d-sm-inline-block">
                        <v-btn
                            text
                            color="primary"
                            class="ml-0 ml-sm-3 mt-2 mt-sm-0"
                            :to="{ name: 'inventory' }"
                        >
                            Afficher tout
                        </v-btn>
                    </span>
                </v-alert>

                <v-row v-if="!fetching && loaded">
                    <template v-if="filteredItems.length > 0">
                        <v-col cols="12" sm="6" md="3" v-for="(item, i) in filteredItems" :key="i" class="d-flex">
                            <VehicleCard :item="item" card-class="my-3" />
                        </v-col>
                    </template>
                    <v-col cols="12" v-else>
                        <v-alert
                            prominent
                            outlined
                            :type="query ? 'warning' : 'info'"
                            color="primary"
                            class="mb-0"
                        >
                            {{ query ? 'Aucun résultat pour "' + query + '".' : "Aucun véhicule à afficher pour le moment." }}
                            <span class="d-block d-sm-inline-block">
                                <v-btn
                                    v-if="query"
                                    text
                                    color="primary"
                                    class="ml-0 ml-sm-3 mt-2 mt-sm-0"
                                    :to="{ name: 'inventory' }"
                                >
                                    Afficher l'inventaire
                                </v-btn>
                            </span>
                        </v-alert>
                    </v-col>
                </v-row>
                <div class="text-center py-12" v-else>
                    <v-progress-circular
                        indeterminate
                        color="primary"
                        size="80"
                    ></v-progress-circular>
                </div>
            </v-container>
        </section>
        </ContentLayout>
    </div>
</template>

<script>
    import ContentLayout from "./../layouts/Content";
    import VehicleCard from "./../elements/VehicleCard";

    export default {
        name: "inventory-view",
        components: {
            ContentLayout,
            VehicleCard
        },
        data: () => ({
            fetching: false,
            items: []
        }),
        computed: {
            heroImage() {
                return this.$store.state.data.page_header_img ? 
                    this.$store.state.data.page_header_img : require("./../../assets/img/hero.jpg");
            },
            query() {
                return this.$route.params.query ? decodeURI(this.$route.params.query) : null;
            },
            filteredItems() {
                return this.items.filter(item => this.query ? JSON.stringify(item).toLowerCase().indexOf(this.query) !== -1 : true);
            },
            loaded() {
                return this.items.find(item => item.loaded == false) ? false : true;
            }
        },
        methods: {
            fetch() {
                this.fetching = true;
                this._apiRequest("items/get-all").then(response => {
                    if(!response.error) {
                        this.items = response.items;
                    } else {
                        this.$root.snackbar.show({
                            text: response.error,
                            icon: "mdi-alert-circle",
                            color: "error"
                        });
                    }
                }).finally(() => {
                    this.fetching = false;
                });
            }
        },
        activated() {
            if(this.items.length === 0) {
                this.fetch();
            }
        }
    };
</script>

<style scoped>
    .inventory-view {
        background: #f5f6f8;
    }

    .inventory-section {
        padding: 64px 0;
    }

    @media (max-width: 599px) {
        .inventory-section {
            padding: 44px 0;
        }
    }
</style>
